import { getRevenueRecognitionDetailRows, getRevenueRecognitionDetailColumns } from "./revenue-recognition-detail-statement";
import { getRevenueRecognitionDetail } from "@/api/finance/reportApi";
import {
  DynamicReport
} from "@/components/dynamic";

const revenueRecognitionDetailFilters = {
  CompanyName: "*",
  CustomerNumber: "*",
  CustomerName: "*",
  BuildingName: "*",
  BuildingNumber: "*",
  ComponentName: "*",
  ComponentNumber: "*",
  UnitName: "*",
  UnitNumber: "*",
  ContractNumber: "*",
  ContractStatus: "*",
};

const revenueRecognitionDetailFilterOptions = [
  { key: "companyName", apiKey: "CompanyName" },
  { key: "customerNumber", apiKey: "CustomerNumber" },
  { key: "customerName", apiKey: "CustomerName", keyType: "label" },
  { key: "componentName", apiKey: "ComponentName", keyType: "label" },
  { key: "componentNumber", apiKey: "ComponentNumber" },
  { key: "buildingName", apiKey: "BuildingName", keyType: "label" },
  { key: "buildingNumber", apiKey: "BuildingNumber" },
  { key: "unitName", apiKey: "UnitName", keyType: "label" },
  { key: "unitNumber", apiKey: "UnitNumber" },
  { key: "contractNumber", apiKey: "ContractNumber", keyType: "label" },
  { key: "contractStatus", apiKey: "ContractStatus" },
];

export default function ReportRevenueRecognitionDetail({ activeCompany }) {
  return (
    <DynamicReport
      reportName="revenue-recognition-details"
      activeCompany={activeCompany}
      columnsDataProvider={getRevenueRecognitionDetailColumns}
      rowsDataProvider={getRevenueRecognitionDetailRows}
      fetchData={getRevenueRecognitionDetail}
      exportUrl="reports/export-query-report/revenue-recognition-details"
      orderBy="CompanyName"
      filtersInitialState={revenueRecognitionDetailFilters}
      filterOptions={revenueRecognitionDetailFilterOptions}
    />
  );
}
